import type { ReactNode } from 'react'

import * as files from 'shared/files'
import { type ContactsTable, LoadingButton, StackIcon } from 'shared/ui'

import { api } from '../api'

export function CSVExport({
	children = 'Export to CSV',
	className,
	filters,
	unSelectAll
}: Pick<ContactsTable.Types.ActionsProps, 'filters' | 'unSelectAll'> & {
	children?: ReactNode
	className?: string
}) {
	const [fetchCSV, { isLoading }] = api.useLazyExportQuery()
	return (
		<LoadingButton
			className={className}
			isLoading={isLoading}
			onClick={async () => {
				const { $filter, $orderby, $searchQuery } = filters

				const { data } = await fetchCSV({
					$filter,
					$orderby,
					$searchQuery
				})

				unSelectAll()
				if (data !== undefined) {
					files.saveFile(data, files.generateName())
				}
			}}
			variant='bordered-dark'
		>
			<StackIcon icon='csv' width={18} />
			{children}
		</LoadingButton>
	)
}
